type Props = {
  total?: number;
  newToday?: number;
  contacted?: number;
  converted?: number;
};

export default function StatsBar({
  total = 0,
  newToday = 0,
  contacted = 0,
  converted = 0,
}: Props) {
  const stats = [
    { label: "Total Leads", value: String(total), icon: "ri-user-add-line", iconBg: "bg-indigo-50", iconColor: "text-indigo-600" },
    { label: "New Today", value: String(newToday), icon: "ri-sparkling-line", iconBg: "bg-green-50", iconColor: "text-green-600" },
    { label: "Contacted", value: String(contacted), icon: "ri-phone-line", iconBg: "bg-amber-50", iconColor: "text-amber-600" },
    { label: "Converted", value: String(converted), icon: "ri-trophy-line", iconBg: "bg-purple-50", iconColor: "text-purple-600" },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat) => (
        <div key={stat.label} className="bg-white rounded-xl border border-gray-200 p-5 hover:border-gray-300 transition-colors">
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">{stat.label}</span>
            <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${stat.iconBg} ${stat.iconColor}`}>
              <i className={`${stat.icon} text-base`} />
            </div>
          </div>
          <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
        </div>
      ))}
    </div>
  );
}